<template>
    <div class="profile-tabs__wrapper">

        <tabs class="profile-tabs" v-if="tabs.length > 1">
            <tab :name="tab.title" :selected="tab.selected" v-for="(tab, index) in tabs" :key="index">


                <div class="profile-tabs__body" v-if="tab.title === 'Благотворители' && tab.array.length > 0" :class="(tab.title === 'Благотворители') ? 'profile-tabs__body--philanthropists': ''">

                    <div class="profile-tabs__body-item d-flex" v-for="(item,index) in tab.array" :key="index">

                        <template v-if="item.user">
                            <div class="profile-tabs__body-header">
                                <a :href="`/user/${item.user.id}/profile`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${item.user.avatar.path.replace('original', 'avatar')}`" :alt="item.user.name" v-if="item.user.avatar">
                                    <span v-else v-text="getUserPM(item.user.name || 'Anonymous')"></span>
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/user/${item.user.id}/profile`" class="profile-tabs__body-name">{{ item.user.name }}</a>
                                <div class="profile-tabs__body-info" v-text="item.total_donated"></div>
                            </div>
                        </template>


                    </div>

                </div>
                <div class="profile-tabs__body" v-else-if="tab.title === 'Поддержал'  && tab.array.length > 0">

                    <div class="profile-tabs__body-item d-flex" v-for="(item,index) in tab.array" :key="index">

                        <template v-if="item.pet">
                            <div class="profile-tabs__body-header">
                                <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${item.pet.avatar.path.replace('original', 'avatar')}`" :alt="item.pet.name" v-if="item.pet.avatar">
                                    <!--                                <span v-else v-text="getUserPM(item)"></span>-->
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-name">{{ item.pet.name }}</a>
                                <div class="profile-tabs__body-info" v-text="item.total_donated"></div>
                            </div>
                        </template>

                        <template v-if="item.project">
                            <div class="profile-tabs__body-header">
                                <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-image">
                                    <img :src="`/storage/${item.project.avatar.path.replace('original', 'avatar')}`" :alt="item.project.name" v-if="item.project.avatar">
                                </a>
                            </div>

                            <div class="profile-tabs__body-content">
                                <a :href="`/projects/${item.project_id}`" class="profile-tabs__body-name">{{ item.project.name }}</a>
                                <div class="profile-tabs__body-info" v-text="item.total_donated"></div>
                            </div>
                        </template>

                    </div>

                </div>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-else>
                    Список пуст
                </div>


            </tab>
        </tabs>

        <div class="profile-tabs"  :class="tabOpen ? 'profile-tabs--open' : ''" v-if="tabs.length === 1">

            <div class="profile-tabs__header-text"
                 @click.prevent="tabOpen = !tabOpen">
                {{ tabs[0].title }}
            </div>

            <transition name="slide" >

                <template  v-if="tabs[0].title === 'Благотворители' && tabs[0].array.length > 0">
                    <div class="profile-tabs__body" v-show="tabOpen"  :class="(tabs[0].title === 'Благотворители') ? 'profile-tabs__body--philanthropists': ''">

                        <div class="profile-tabs__body-item d-flex" v-for="(item,index) in tabs[0].array" :key="index">

                            <template v-if="item.user">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/user/${item.user.id}/profile`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${item.user.avatar.path.replace('original', 'avatar')}`" :alt="item.user.name" v-if="item.user.avatar">
                                        <span v-else v-text="getUserPM(item.user.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/user/${item.user.id}/profile`" class="profile-tabs__body-name">{{ item.user.name }}</a>
                                    <div class="profile-tabs__body-info" v-text="item.total_donated"></div>
                                </div>
                            </template>


                        </div>

                    </div>
                </template>
                <template  v-else-if="tabs[0].title === 'Поддержал' && tabs[0].array.length > 0">
                    <div class="profile-tabs__body" v-show="tabOpen">

                        <div class="profile-tabs__body-item d-flex" v-for="(item,index) in tabs[0].array" :key="index">

                            <template v-if="item.pet">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${item.pet.avatar.path.replace('original', 'avatar')}`" :alt="item.pet.name" v-if="item.pet.avatar">
                                        <!--                                <span v-else v-text="getUserPM(item)"></span>-->
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${item.pet_id}`" class="profile-tabs__body-name">{{ item.pet.name }}</a>
                                    <div class="profile-tabs__body-info" v-text="item.total_donated"></div>
                                </div>
                            </template>

                        </div>

                    </div>
                </template>
                <template v-else>
                    <div class="profile-tabs__body profile-tabs__body--empty d-flex" v-show="tabOpen">

                        Список пуст

                    </div>
                </template>


            </transition>

        </div>

    </div>
</template>

<script>
import Tabs from './tabs/Tabs';
import Tab from './tabs/Tab';
export default {
    components: {
        Tabs,
        Tab
    },
    props: ['user'],
    name: "ProfileTabs.vue",
    data() {
        return{
            tabOpen: true,
            tabs: [],
        }
    },
    mounted() {
        this.getDonationsSupervised();
        this.getDonationsByUser();
    },

    methods:{

        getDonationsByUser() {
            let url = `/user/${this.user.id}/donations/by-user`;

            axios.get(url)
                .then(response => {
                    response = response.data;
                    if(response.success && response.data.length > 0){
                        this.tabs.push({
                            title: 'Поддержал',
                            selected: false,
                            array: response.data
                        });
                    } else {
                        this.tabs.push({
                            title: 'Поддержал',
                            selected: false,
                            array: []
                        });
                    }

                })
                .catch()

        },

        getDonationsSupervised() {
            let url = `/user/${this.user.id}/donations/supervised`;

            axios.get(url)
                .then(response => {
                    response = response.data;
                    if(response.success && response.data.length > 0){
                        this.tabs.push({
                            title: 'Благотворители',
                            selected: true,
                            array: response.data
                        });
                    } else {
                        this.tabs.push({
                            title: 'Благотворители',
                            selected: true,
                            array: []
                        });
                    }

                })
                .catch()

        },

        getUserPM(name){
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },
    },
}
</script>

<style lang="scss" scoped>

.slide-enter-active, .slide-leave-active {
    transition: max-height .2s ease, opacity .1s ease;
}

.slide-enter, .slide-leave-to {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

.slide-enter-to, .slide-leave {
    max-height: 565px;
    opacity: 1;
    overflow: hidden;
}


@media screen and (max-width: 992px){
/*    .profile-tabs__wrapper{
        margin-top: 15px;
    }

    .profile-tabs{
        width: 100%;
        max-width: 400px;
        margin: auto;

    }*/
}
/*
@media screen and (max-width: 768px){
    .profile-tabs__body-name{
        font-size: 13px;
    }
}

@media screen and (max-width: 500px){
    .profile-tabs{
        max-width: 100%;
    }
}
*/

</style>
